
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#9B9B9B","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M21.597 8.396c0-4.313-3.509-7.822-7.822-7.822-2.834 0-5.312 1.52-6.685 3.784-3.726.238-6.687 3.336-6.687 7.12 0 3.629 2.721 6.627 6.228 7.08v2.489a.917.917 0 001.613.595l4.517-5.28a.857.857 0 00.097-.14v2.782a.918.918 0 001.614.596l5.008-5.856c.017-.02.03-.043.046-.065a7.784 7.784 0 002.07-5.283m-7.82-5.988a5.995 5.995 0 015.987 5.988 5.995 5.995 0 01-5.988 5.988 5.995 5.995 0 01-5.988-5.988 5.995 5.995 0 015.988-5.988m-11.538 9.07c0-2.475 1.705-4.555 4-5.14a7.784 7.784 0 00-.283 2.058c0 3.275 2.026 6.082 4.888 7.245a5.265 5.265 0 01-3.294 1.149 5.317 5.317 0 01-5.311-5.311"}}),_c('path',{attrs:{"d":"M12.269 8h3.014a.917.917 0 000-1.833h-3.014a.917.917 0 000 1.833M12.269 11.132h3.014a.917.917 0 000-1.833h-3.014a.917.917 0 000 1.833"}})])])
          )
        }
      }
    